import LoginPage from 'views/Auth/LoginPage';
import ProfilePage from 'views/Auth/ProfilePage';
import ForgotPasswordPage from 'views/Auth/ForgotPasswordPage';
import NewPasswordPage from 'views/Auth/NewPasswordPage';
import StudentRegister from 'views/Auth/StudentRegister';
import StudentRegisterRep from 'views/Auth/StudentRegisterRep';
import StudentRegisterNonRep from 'views/Auth/StudentRegisterNonRep';
import CollegeRegister from 'views/Auth/CollegeRegister';
import ProHrRegister from 'views/Auth/ProHrRegister';
import AssociationRegister from 'views/Auth/AssociationRegister';
import GuestRegister from 'views/Auth/GuestRegister';
import WaitingPage from 'views/Auth/WaitingPage';
import confirmEmail from 'views/Auth/ConfirmPro';
import ChangeDiary from 'views/Auth/ChangeDiary';
import Router from './routesHOC';

export const routes = [
  {
    path: '/auth/eleve',
    component: StudentRegister,
  },
  {
    path: '/auth/eleve-rep',
    component: StudentRegisterRep,
  },
  {
    path: '/auth/eleve-non-rep',
    component: StudentRegisterNonRep,
  },
  {
    path: '/auth/edit_diary',
    component: ChangeDiary,
  },
  {
    path: '/auth/college',
    component: CollegeRegister,
  },
  {
    path: '/auth/association',
    component: AssociationRegister,
  },
  {
    path: '/auth/guest',
    component: GuestRegister,
  },
  {
    path: '/auth/professionnel',
    component: ProHrRegister,
  },
  {
    path: '/auth/entreprise',
    component: ProHrRegister,
  },
  {
    path: '/auth/profil',
    component: ProfilePage,
  },
  {
    path: '/auth/nouveau-mot-de-passe',
    component: NewPasswordPage,
  },
  {
    path: '/auth/bienvenue',
    component: WaitingPage,
  },
  {
    path: '/auth/inscription/:source',
    component: ProfilePage,
  },
  {
    path: '/auth/inscription/',
    component: ProfilePage,
  },
  {
    path: '/auth/connexion',
    component: LoginPage,
  },
  {
    path: '/auth/mot-de-passe',
    component: ForgotPasswordPage,
  },
  {
    path: '/auth/confirm-email/',
    component: confirmEmail,
  },
  {
    path: '/auth/',
    pathTo: '/auth/connexion',
  },
];

export default Router(routes);
